import React, { useState, useEffect } from 'react';
import {
  ContentLayout,
  Header,
} from '@cloudscape-design/components';
import Board from '@cloudscape-design/board-components/board';
import { useParams } from 'react-router-dom';
import GeneralLocationInformation from '../widgets/GeneralLocationInformation'; // Import GeneralLocationInformation
import ContactInformation from '../widgets/ContactInformation'; // Import ContactInformation
import HubIsetStatistics from '../widgets/HubIsetStatistics';
import { apiFetch } from '../auth/apiClient';

const ModifyLocation = ({ header, headerInfo, toggleHelpPanel, updateBreadcrumbs }) => {
  const { id } = useParams();
  const [hub, setHub] = useState(null);
  const [items, setItems] = useState([
    {
      id: 'general-information',
      rowSpan: 4,
      columnSpan: 2,
      data: { title: 'General Information' },
    },
    {
      id: 'contact-information',
      rowSpan: 3,
      columnSpan: 2,
      data: { title: 'Contact Information' },
    },
    {
      id: 'hub-iset-statistics',
      rowSpan: 3,
      columnSpan: 2,
      data: { title: 'Hub ISET Statistics' },
    }
  ]);

  useEffect(() => {
    apiFetch(`/api/hubs/${id}`)
      .then(response => response.json())
      .then(data => {
        setHub(data);
        console.log('Updating breadcrumbs with Hub:', data.full_name);
        updateBreadcrumbs([
          { text: 'Home', href: '/' },
          { text: 'NWAC Hub Management', href: '/nwac-hub-management' },
          { text: data.full_name, href: '#' }
        ]);
      })
      .catch(error => console.error('Error fetching Hub:', error));
  }, [id, updateBreadcrumbs]);

  useEffect(() => {
    if (hub) {
      updateBreadcrumbs([
        { text: 'Home', href: '/' },
        { text: 'NWAC Hub Management', href: '/nwac-hub-management' },
        { text: hub.full_name, href: '#' }
      ]);
    }
  }, [hub, updateBreadcrumbs]);

  if (!hub) {
    return <div>Loading...</div>;
  }

  return (
    <ContentLayout
      header={
        <Header variant="h1" info={headerInfo}>
          {header}
        </Header>
      }
    >
      <Board
        renderItem={(item) => {
          if (item.id === 'general-information') {
            return <GeneralLocationInformation />;
          }
          if (item.id === 'contact-information') {
            return <ContactInformation hub={hub} />;
          }
          if (item.id === 'hub-iset-statistics') {
            return <HubIsetStatistics />;
          }
          return null;
        }}
        items={items}
        onItemsChange={(event) => setItems(event.detail.items)}
        i18nStrings={{
          liveAnnouncementDndStarted: (operationType) =>
            operationType === 'resize' ? 'Resizing' : 'Dragging',
          liveAnnouncementDndItemReordered: (operation) => {
            const columns = `column ${operation.placement.x + 1}`;
            const rows = `row ${operation.placement.y + 1}`;
            return `Item moved to ${operation.direction === 'horizontal' ? columns : rows}.`;
          },
          liveAnnouncementDndItemResized: (operation) => {
            const columnsConstraint = operation.isMinimalColumnsReached ? ' (minimal)' : '';
            const rowsConstraint = operation.isMinimalRowsReached ? ' (minimal)' : '';
            const sizeAnnouncement = operation.direction === 'horizontal'
              ? `columns ${operation.placement.width}${columnsConstraint}`
              : `rows ${operation.placement.height}${rowsConstraint}`;
            return `Item resized to ${sizeAnnouncement}.`;
          },
          liveAnnouncementDndItemInserted: (operation) => {
            const columns = `column ${operation.placement.x + 1}`;
            const rows = `row ${operation.placement.y + 1}`;
            return `Item inserted to ${columns}, ${rows}.`;
          },
          liveAnnouncementDndCommitted: (operationType) => `${operationType} committed`,
          liveAnnouncementDndDiscarded: (operationType) => `${operationType} discarded`,
          liveAnnouncementItemRemoved: (op) => `Removed item ${op.item.data.title}.`,
          navigationAriaLabel: 'Board navigation',
          navigationAriaDescription: 'Click on non-empty item to move focus over',
          navigationItemAriaLabel: (item) => (item ? item.data.title : 'Empty'),
        }}
      />
    </ContentLayout>
  );
};

export default ModifyLocation;
